import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ZipcodeMaskDirective } from './directives/zipcode-mask.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { PageHeaderModule } from '@pics-core/page-header';
import { ProfileSettingsModule } from '@pics-core/profile';
import { PageHeaderComponent } from './modules';
import { ModalComponent } from './custom-component/modal/modal.component';
import { AlertModule } from './modules/alert/alert.module';
@NgModule({
  imports: [CommonModule, PrimengModule, MaterialUIModule, ReactiveFormsModule,
    PageHeaderModule, 
    ProfileSettingsModule,ModalComponent,
    AlertModule
       ],
  declarations: [PageHeaderComponent, ZipcodeMaskDirective],
  exports: [PageHeaderComponent, ModalComponent, AlertModule, ZipcodeMaskDirective]
})
export class SharedModule {
  static forRoot(): any[] | import('@angular/core').Type<any> | import('@angular/core').ModuleWithProviders<any> {
    throw new Error('Method not implemented.');
  }
}
